/**
 * Inicjalizacja logiki strzałek nawigacyjnych (sekcja 6)
 * - Aktywuje odpowiednie strzałki w zależności od widocznej sekcji.
 * - Udostępnia funkcję simulateKey() do symulacji wciśnięcia klawiszy.
 */

export function initComicsNavigations() {
  const arrows = {
    up:    document.getElementById("arrow-up"),
    down:  document.getElementById("arrow-down"),
    left:  document.getElementById("arrow-left"),
    right: document.getElementById("arrow-right"),
  };

  const sectionConfigs = {
    section6a: ["right"],
    section6b: ["right", "left"],
    section6c: ["right", "left"],
    section6d: ["right", "left"],
    section6e: ["left", "down"],
  };

  // Filtruj tylko sekcje, które istnieją w DOM
  const sections = Object.keys(sectionConfigs)
    .map(id => document.getElementById(id))
    .filter(Boolean);

  // --- Pomocnicze funkcje ---
  function updateArrowsFor(sectionId) {
    // usuń active ze wszystkich
    Object.values(arrows).forEach(el => el?.classList.remove("active"));

    // dodaj active tym, które są zdefiniowane dla danej sekcji
    const activeArrows = sectionConfigs[sectionId] || [];
    activeArrows.forEach(dir => {
      if (arrows[dir]) arrows[dir].classList.add("active");
    });
  }
  function simulateKey(key) {
    const keyCodes = {
      ArrowUp: 38,
      ArrowDown: 40,
      ArrowLeft: 37,
      ArrowRight: 39,
    };

    const event = new KeyboardEvent("keydown", {
      key,
      code: key,
      keyCode: keyCodes[key],
      which: keyCodes[key],
      bubbles: true,
    });

    document.dispatchEvent(event);
  }

  // Udostępnij globalnie, jeśli inne moduły mają z tego korzystać
  window.simulateKey = simulateKey;

  //  Obserwacja widoczności sekcji 
  // IntersectionObserver = elegancki sposób sprawdzania, która sekcja jest widoczna
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          updateArrowsFor(entry.target.id);
        }
      });
    },
    { threshold: 0.6 } // 60% widoczności sekcji
  );

  sections.forEach(section => observer.observe(section));
}
